import React, {createContext, ReactNode, useContext, useEffect, useState} from 'react';
import {useZooPassAppContext} from "../../Context/ZooPassAppContext";
import {IZooPassAnswersContext, useZooPassAppAnswersContext, ZooPassAppAnswersContext} from "../../Context/ZooPassAnswersContext";
import {StepTitleContent} from "../PanelContents/StepTitleContent";
import {ImageAnswerComponent} from "../PanelContents/ImageAnswer";
import ZooPassLocalStateUtility from "../../Utilities/ZooPassLocalStateUtility";
import ZooPassAnswerAvailabilityUtility from "../../Utilities/ZooPassAnswerAvailabilityUtility";
import {PassSelectCard} from "../PanelContents/PassSelectCard";
import classNames from 'classnames';
import ZooPassStepDataUtility from "../../Utilities/ZooPassStepDataUtility";
export const Step8Panel: React.FC = () => {

    const tabIndex = 0;
    const [rows, setRows] = useState<Array<ReactNode>>([]);

    let {
        dictionary,
        textTitles,
        zooPassMembership,
        loading
    } = useZooPassAppContext();

    let {
        answersData,
        answersLoading,
        updateContext
    } = useZooPassAppAnswersContext();

    useEffect(() => {
        if (answersData == null || zooPassMembership == null) {
            setRows([]);
            return;
        }
        
        let fetchKey = answersData.step7Value;
        if(fetchKey == null) return;
        let membership = zooPassMembership.get(fetchKey);
        if(membership == null) return;
        let yearSet = answersData.step1Value == 1 ? membership.gift : membership.member;
        let items = [yearSet.y1, yearSet.y2, yearSet.y3];
        
        let newRows: Array<ReactNode> = [];
        items.forEach((option, index) => {
            if (!option) return;
            
            const index1 = index + 1;
            const perYear = Math.ceil(option.amount / index1);
            
            let savingsItem = (<span className="text--muted d-none d-md-block">&nbsp;</span>);
            if(index1 == 2) savingsItem = (<span className="text--muted d-none d-md-block">{dictionary.get("ZooPass:StepLayout:08:Save5")}</span>);
            if(index1 == 3) savingsItem = (<span className="text--muted d-none d-md-block">{dictionary.get("ZooPass:StepLayout:08:Save10")}</span>);
            
            newRows.push(<div className={classNames("col", "h-100",{"is-recommended": index > 0})}>
                <div className={classNames("featured", {"d-none": index != 0})}>
                    <h5 className="h6">&nbsp;</h5>
                </div>
                <div className={classNames("text-center", "featured", {"d-none": index != 1})}>
                    <h5 className="h6">{dictionary.get("ZooPass:StepLayout:08:GoodValue")}</h5>
                </div>
                <div className={classNames("text-center", "featured", {"d-none": index != 2})}>
                    <h5 className="h6">{dictionary.get("ZooPass:StepLayout:08:BestValue")}</h5>
                </div>
                <div className="radio radio--wrapped radio--vertical radio--white">
                    <label tabIndex={tabIndex} className="radio__label" onClick={() => handleValueClick(option.id, index1 as 1 | 2 | 3)} onKeyUpCapture={(event) => handleOptionKeyPress(event, option.id, index1 as 1 | 2 | 3)}>
                        <input type="radio" name="years" className="d-none"/>
                        <div className="radio__label-content">
                            <div className="price">
                                {savingsItem}
                                <h5 className="h1 text--0">${option.amount}</h5>
                                <p>{dictionary.get("ZooPass:StepLayout:08:Total")}</p>
                            </div>
                            <div>
                            <h6 className="mb-0">{dictionary.get("ZooPass:StepLayout:08:ValueText:" + index1)}</h6>
                                <p>
                                    {dictionary.get("ZooPass:StepLayout:08:PerYearText:Prefix")} <span className="text--0 text--bold">${perYear}</span> {dictionary.get("ZooPass:StepLayout:08:PerYearText:Suffix")}
                                </p>
                            </div>
                        </div>
                    </label>
                </div>
            </div>);
        });
        setRows(newRows);

    }, [answersData?.step, answersData?.step3Value, answersData?.step4FinalValue, answersData?.step5Value]);

    const handleValueClick = (value: null | string, years : 1 | 2 | 3) => handleValueSelected(value, years);
    
    const handleOptionKeyPress = (event : any, value: null | string, years : 1 | 2 | 3) => {
        if(!event.altKey && !event.metaKey && !event.shiftKey && event.key === 'Enter') {
            handleValueSelected(value, years);
        }
    }
    
    const handleValueSelected = (value: null | string, years : 1 | 2 | 3) => {
        if(answersData != null && value != null) {
            answersData.step8IdValue = value;
            answersData.step8Value = years;
            answersData.previousStep = answersData.step;
            answersData.step = 9;
            ZooPassLocalStateUtility.SetLocalState(answersData);
            updateContext({type: "setAnswers", value: answersData});
        }
    }

    return !answersLoading && !loading &&
        textTitles !== null &&
        answersData !== null && answersData.step == 8 && (
            <div className="container d-block">
                <StepTitleContent textTitle={textTitles.get("ZooPass:PageContent:08")}/>
                <div className="row g-4 w-100 row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 row-cols-xxl-5 justify-content-center zoopass--step8">
                    {rows}
                </div>
            </div>
        );
};

